module.exports = __webpack_public_path__ + "static/img/old_star_person_service.c1199e8a.png";